<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div class="cover">
    <div
      v-move="{
        pos: props[item.posKey],
        change: (left:number, top:number) => onPosChange(item.posKey, left, top)
      }"
      v-input="{
        value: props[item.valueKey],
        change: (value:string) => onValueChange(item.valueKey, value)
      }"
      v-for="(item, index) in info"
      :data-edit="useEdit"
      :key="index"
      :class="{ [item.className]: true }"
      v-html="props[item.valueKey]"
    ></div>
  </div>
</template>

<script setup lang="tsx">
import { vMove, vInput, useCover } from './index';
type Pos = { left: number; top: number; center?: boolean; initHeight?: number };
const props = withDefaults(
  defineProps<{
    useEdit?: boolean;
    projectName: string;
    time: string;
    mainPageEnterpriseName: string;
    titlePosition: Pos;
    settleTimePosition: Pos;
    aspNamePosition: Pos;
    orderNumber: string | number;
    orderNumberPostion: Pos;
  }>(),
  {}
);

const emits = defineEmits(['posChange', 'valueChange']);

const { info, onPosChange, onValueChange } = useCover(emits);
</script>
<style lang="scss" scoped>
.cover {
  background-image: url('https://cdn.yxvzb.com/WEB/SaaS/bi-v3/images/coever-1-templ.png');
  background-size: calc(100% + 40px);
  background-repeat: no-repeat;
  background-position: -10px -10px;
  height: calc(var(--page-v3-height, 100%) - 2px);
  position: relative;
}
.project-name,
.time,
.order-number,
.enterprise-name {
  position: absolute;
  z-index: 2;
  user-select: none;
}
.project-name,
.time {
  font-size: 63px;
  font-weight: 600;
  color: #404040;
  text-align: center;
}

.project-name {
  width: 800px;
  color: #fff;
  &::before {
    content: '';
    width: 200%;
    height: calc(100% + 200px);
    background-color: var(--theme-color-1);
    position: absolute;
    left: -50%;
    top: -70px;
    z-index: -1;
  }
}
.time {
  font-size: 36px;
  width: 350px;
  text-align: center;
  color: #484848;
}
.enterprise-name {
  font-size: 36px;
  font-weight: 600;
  text-align: center;
  width: 650px;
  color: #484848;
}
.order-number {
  font-size: 46px;
  font-weight: 500;
  color: #ffffff;
  font-family: PingFang SC;
  font-weight: 600;
}
</style>
